"use strict";
/* THIS IS A GENERATED FILE */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkubanaProductApiClient = void 0;
const BaseApiClient_1 = require("./BaseApiClient");
class SkubanaProductApiClient extends BaseApiClient_1.BaseApiClient {
    async retrieveProduct(queryParams) {
        const path = `/v1.1/product`;
        return await this.request("get", path, queryParams, undefined);
    }
    async retrieveProducts(queryParams) {
        const path = `/v1.1/products`;
        return await this.request("get", path, queryParams, undefined);
    }
    async createBundleProducts(bundleProducts) {
        const path = `/v1.1/products/bundles`;
        return await this.request("put", path, undefined, bundleProducts);
    }
    async createCoreProducts(coreProducts) {
        const path = `/v1.1/products/cores`;
        return await this.request("put", path, undefined, coreProducts);
    }
    async deleteCustomFieldDefinitions(deleteCustomFieldDefs) {
        const path = `/v1.1/products/customfielddefinitions`;
        return await this.request("delete", path, undefined, deleteCustomFieldDefs);
    }
    async retrieveCustomFieldDefinitions(queryParams) {
        const path = `/v1.1/products/customfielddefinitions`;
        return await this.request("get", path, queryParams, undefined);
    }
    async createCustomFieldsDefinitions(putCustomFieldDefinitions) {
        const path = `/v1.1/products/customfielddefinitions`;
        return await this.request("put", path, undefined, putCustomFieldDefinitions);
    }
    async createProductVariations(productVariations) {
        const path = `/v1.1/products/variations`;
        return await this.request("put", path, undefined, productVariations);
    }
    async createVirtualProducts(virtualProducts) {
        const path = `/v1.1/products/virtuals`;
        return await this.request("put", path, undefined, virtualProducts);
    }
    async deleteCustomFieldValues(productId, deleteCustomFieldValues) {
        const path = `/v1.1/products/${productId || ""}/customfieldvalues`;
        return await this.request("delete", path, undefined, deleteCustomFieldValues);
    }
    async retrieveCustomFieldValues(productId) {
        const path = `/v1.1/products/${productId || ""}/customfieldvalues`;
        return await this.request("get", path, undefined, undefined);
    }
    async createCustomFieldValues(productId, putCustomFieldValues) {
        const path = `/v1.1/products/${productId || ""}/customfieldvalues`;
        return await this.request("put", path, undefined, putCustomFieldValues);
    }
    async removeLabelsFromProduct(productId, queryParams) {
        const path = `/v1/product/${productId || ""}/labels`;
        return await this.request("delete", path, queryParams, undefined);
    }
    async getLabelsForProduct(productId) {
        const path = `/v1/product/${productId || ""}/labels`;
        return await this.request("get", path, undefined, undefined);
    }
    async assignLabelsForProduct(productId, queryParams) {
        const path = `/v1/product/${productId || ""}/labels`;
        return await this.request("post", path, queryParams, undefined);
    }
    async updateExistingProducts(postProducts) {
        const path = `/v1/products`;
        return await this.request("post", path, undefined, postProducts);
    }
    async deleteExistingCategory(deleteCategory) {
        const path = `/v1/products/categories`;
        return await this.request("delete", path, undefined, deleteCategory);
    }
    async renameExistingCategory(postCategory) {
        const path = `/v1/products/categories`;
        return await this.request("post", path, undefined, postCategory);
    }
    async createNewProductCategory(putCategory) {
        const path = `/v1/products/categories`;
        return await this.request("put", path, undefined, putCategory);
    }
    async createNewProductImage(queryParams) {
        const path = `/v1/products/images`;
        return await this.request("put", path, queryParams, undefined);
    }
    async createVariationAttributes(putAttribute) {
        const path = `/v1/products/variations/attributes`;
        return await this.request("put", path, undefined, putAttribute);
    }
    async getAttributeGroups(queryParams) {
        const path = `/v1/products/variations/attributes/groups`;
        return await this.request("get", path, queryParams, undefined);
    }
    async createNewAttributeGroup(putAttributeGroup) {
        const path = `/v1/products/variations/attributes/groups`;
        return await this.request("put", path, undefined, putAttributeGroup);
    }
}
exports.SkubanaProductApiClient = SkubanaProductApiClient;
